import { ApplicationFormData } from "pages/NewApplication/steps/types";

import { useCallback, useState } from "react";

function parseIfNotNull<T>(s: string | null): T | null {
	return s && JSON.parse(s);
}

const LocalStorageHelper = {
	applicationDraftKey: "application_draft",
	backofficeListFiltersKey: "backoffice_list_filters",
	backofficeRegistryFiltersKey: "backoffice_registry_filters",
	backofficeListPageSizeKey: "backoffice_list_page_size",
	backofficeRegistryPageSizeKey: "backoffice_registry_page_size",
	applicationAnalysesPageSizeKey: "application_analyses_page_size",
	applicationHistoryPageSizeKey: "application_history_page_size",
	backofficeListSearchTextKey: "backoffice_list_search_text",
	backofficeRegistrySearchTextKey: "backoffice_registry_search_text",

	getApplicationDraft(): ApplicationFormData | null {
		const dataString = localStorage.getItem(
			LocalStorageHelper.applicationDraftKey
		);
		return dataString && JSON.parse(dataString);
	},
	setApplicationDraft(draftData: ApplicationFormData): void {
		localStorage.setItem(
			LocalStorageHelper.applicationDraftKey,
			JSON.stringify(draftData)
		);
	},
	removeApplicationDraft(): void {
		localStorage.removeItem(LocalStorageHelper.applicationDraftKey);
	},

	useLocalStorageState<T>(
		key: string,
		toString: (value: T | null) => string = JSON.stringify,
		toValue: (stringifiedValue: string | null) => T | null = parseIfNotNull
	): [T | null, (newValue: T | null) => void] {
		const [stateValue, setStateValue] = useState<T | null>(() =>
			toValue(localStorage.getItem(key))
		);
		const stateSetter = useCallback(
			(newValue: T | null) => {
				const newValueString = toString(newValue);
				localStorage.setItem(key, newValueString);
				setStateValue(newValue);
			},
			[key, setStateValue]
		);
		return [stateValue, stateSetter];
	}
};

export default LocalStorageHelper;
